// src/app/app.module.ts
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComplydomeComponent } from './complydome/complydome.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GenericConfirmationDialogComponent } from './generic-confirmation-dialog/generic-confirmation-dialog.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './shared/shared.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { CD_DATE_FORMATS } from "./date-formats";
import { MatMomentDateModule, MomentDateAdapter } from "@angular/material-moment-adapter";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { LogoutOn401Interceptor } from "./logout-on-401.interceptor";
import { NoCacheInterceptor } from "./no-cache.interceptor";
import { ReportsComponent } from './features/reports/reports.component';
import { appInitializer } from "./app.initializer";
import { ConstantsService } from "./constants.service";
import { PolicyService } from "./policy.service";
import { PolicyRepositoryApi } from './features/policy-management/repositories/PolicyRepositoryApi';



@NgModule({
  declarations: [
    AppComponent,
    ComplydomeComponent,
    GenericConfirmationDialogComponent,
    ReportsComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatIconModule,
    SharedModule,
    MatMomentDateModule,
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter }, // Use MomentDateAdapter
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' }, // Change to your locale
    { provide: MAT_DATE_FORMATS, useValue: CD_DATE_FORMATS }, // Use custom format
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LogoutOn401Interceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [ConstantsService, PolicyService],
      multi: true
    },
    {
      provide: 'PolicyRepositoryInterface',
      useClass: PolicyRepositoryApi,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
